<template>
  <div class="qrblock">
    <div ref="qrcode-box"></div>
  </div>
</template>

<script>
export default {
  name: 'qrcode',
  props:[
    'text',
  ],
  mounted(){
    new window.QRCode(this.$refs['qrcode-box'], this.text)
  },
}
</script>

<style scoped lang="scss">
  .qrblock{
    border: 5px solid #fff;

    /deep/ img{
      max-width: 100%;
    }
  }
</style>
